import { Outlet } from 'react-router';

export function AuthLayout() {
  return (
    <div className='flex min-h-screen items-center justify-center bg-gradient-to-b from-muted/40 to-background p-4'>
      <div className='w-full max-w-sm'>
        <div className='mb-8 flex flex-col items-center text-center'>
          <img
            src='/assets/brand/kim-ai-logo.svg'
            className='mb-4 h-12 w-12'
            alt='Kim'
          />
          <h1 className='text-xl font-semibold tracking-tight'>
            Kim Control Panel
          </h1>
          <p className='mt-1 text-sm text-muted-foreground'>
            Sign in with your Kim work account
          </p>
        </div>
        <Outlet />
      </div>
    </div>
  );
}
